/// <amd-module name="Wit/LinkedWorkItemsDropdown/RestClient/WitBatchRestClient" />
import { IVssPageContext, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";
import {
    IWorkItemTrackingHttpBatchClient,
    JsonHttpRequest,
    JsonHttpResponse,
    JsonPatchDocument,
    JsonPatchOperation,
    Operation
} from "Wit/LinkedWorkItemsDropdown/Contracts/WitBatchRestClient";

const ApiVersion = "4.0-preview";

export class WorkItemTrackingHttpBatchClient extends RestClientBase implements IWorkItemTrackingHttpBatchClient {
    /**
     * [Preview API]
     *
     * @param updateDocuments
     * @return IPromise<JsonHttpResponse[]>
     */
    public updateWorkItemsBatch(updateDocuments: [number, JsonPatchDocument][]): Promise<JsonHttpResponse[]> {
        const requests = updateDocuments.map(updateDocument => this._createBatchRequest(updateDocument[0], "PATCH", "workItems", updateDocument[1]));

        return this._beginBatchRequest(requests);
    }

    private _createBatchRequest(id: number | string, httpMethod: string, resource: string, body?: any): JsonHttpRequest {
        return {
            method: httpMethod,
            uri: `/_apis/wit/${resource}/${id}?api-version=${ApiVersion}`,
            headers: {
                "Content-Type": "application/json-patch+json"
            },
            body: body
        } as JsonHttpRequest;
    }

    private _beginBatchRequest(requests: JsonHttpRequest[]): Promise<JsonHttpResponse[]> {
        return this.beginRequest<JsonHttpResponse[]>({
            method: "POST",
            routeTemplate: "_apis/{area}/${resource}",
            routeValues: {
                area: "wit",
                resource: "batch"
            },
            apiVersion: ApiVersion,
            body: requests
        });
    }
}

export function getWorkItemPatchAddOperation(artifactUri: string | undefined, artifactLinkName: string): JsonPatchOperation {
    return {
        op: Operation.Add,
        path: "/relations/-",
        value: {
            attributes: { name: artifactLinkName },
            rel: "ArtifactLink",
            url: artifactUri
        }
    } as JsonPatchOperation;
}

export function getWorkItemPatchTestOperation(index: number, serverUri: string): JsonPatchOperation {
    return {
        op: Operation.Test,
        path: "/relations/" + index + "/url",
        value: serverUri
    } as JsonPatchOperation;
}

export function getWorkItemRemoveLinkOperation(deleteIndex: number): JsonPatchOperation {
    return {
        op: Operation.Remove,
        path: "/relations/" + deleteIndex
    } as JsonPatchOperation;
}

export function getWorkItemPatchRemoveDocument(deleteIndex: number, serverUri: string): JsonPatchDocument {
    const testOp = getWorkItemPatchTestOperation(deleteIndex, serverUri);
    const patchOp = getWorkItemRemoveLinkOperation(deleteIndex);

    return [testOp, patchOp];
}

const WitClientName = "Repos.FilesHubActions.IWorkItemTrackingHttpBatchClient";

export function getWitBatchClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IWorkItemTrackingHttpBatchClient {
    return pageContext.getRestClient<IWorkItemTrackingHttpBatchClient>(WitClientName, options);
}

RestClients.add(WitClientName, {
    factory: WorkItemTrackingHttpBatchClient,
    options: {
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
